import { Col, Row } from 'react-bootstrap';
import { formatPrice } from '../../../utils/utils';

export type ColumnsLegendCustomProps = React.PropsWithChildren<{
  colors: any[];
  total?: any;
  series: { name: string; data: number[] }[];
  isPrice?: boolean;
}>;

const ColumnsCustomLegend = ({
  colors,
  total,
  series,
  isPrice = true,
}: ColumnsLegendCustomProps) => {
  const getColumnLegendItems = () => {
    var items = series.map((item, index) => {
      return {
        id: index,
        value: item,
        label: item,
        colour: colors[index],
      };
    });
    return items;
  };

  return (
    <>
      <Row>
        {!isPrice ? (
          <Col className={'col-12 border-bottom-light-gray-2px text-end py-3'}>
            <span className={'lh-xxs fw-normal text-fs-6 text-ligther-grey '}>
              Score
            </span>
          </Col>
        ) : (
          <></>
        )}

        <Col>
          {getColumnLegendItems().map((item, index) => (
            <Row
              key={index}
              className="text-fs-6 fw-light lh-xs pt-3 pb-3 border-bottom align-items-center"
            >
              <Col className="d-flex pt-1 col-6 align-items-center">
                <div
                  className="custom-legend-marker"
                  style={{
                    backgroundColor: item.colour.toString(),
                  }}
                ></div>
                <div className="ms-3">{item.label.name.toString()}</div>
              </Col>
              {item.value.data.map((num, index: number) => (
                <Col key={index} className="text-end">
                  {isPrice
                    ? formatPrice(num, 'en-US', {
                        currency: 'USD',
                        style: 'currency',
                        minimumFractionDigits: 0,
                      })
                    : num}
                </Col>
              ))}
            </Row>
          ))}

          {total !== undefined ? (
            <Row className="text-fs-6 fw-normal pt-3 pb-3 lh-xs border-bottom">
              <Col className="col-6">TOTAL</Col>
              {total.map((num: any, index: number) => (
                <Col key={index} className="text-end">
                  {num.toString()}
                </Col>
              ))}
            </Row>
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </>
  );
};

export default ColumnsCustomLegend;
